"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILTER_STRIP = exports.FILTER_NOTHING = exports.FILTER_INLINE = exports.FILTER_BASIC = void 0;
const sanitize_html_1 = __importStar(require("sanitize-html"));
exports.FILTER_BASIC = sanitize_html_1.defaults;
exports.FILTER_INLINE = {
    allowedTags: ['a', 'b', 'br', 'code', 'em', 'i', 'span', 'strike', 'strong', 'u'],
    allowedAttributes: {
        a: ['href', 'target'],
        span: ['style']
    },
    selfClosing: ['br'],
    allowedSchemes: ['ftp', 'http', 'https', 'mailto'],
    parser: {
        decodeEntities: true
    }
};
exports.FILTER_NOTHING = {
    allowedTags: false,
    allowedAttributes: false
};
exports.FILTER_STRIP = {
    allowedTags: [],
    allowedAttributes: {}
};
const VSanitize = {
    install(Vue, options = {}) {
        const defaultOptions = options;
        const { name = 'sanitize' } = defaultOptions;
        delete defaultOptions.name;
        const options1 = { ...defaultOptions };
        Vue.prototype[`$${name}`] = (dirty, opts = undefined) => (0, sanitize_html_1.default)(dirty, opts || options1);
        Vue.directive(name, (el, binding) => {
            if (binding.value !== binding.oldValue) {
                if (Array.isArray(binding.value)) {
                    el.innerHTML = (0, sanitize_html_1.default)(binding.value[1], binding.value[0]);
                }
                else {
                    if (binding.modifiers.strip) {
                        el.innerHTML = (0, sanitize_html_1.default)(binding.value, exports.FILTER_STRIP);
                    }
                    else if (binding.modifiers.basic) {
                        el.innerHTML = (0, sanitize_html_1.default)(binding.value, options1);
                    }
                    else if (binding.modifiers.inline) {
                        el.innerHTML = (0, sanitize_html_1.default)(binding.value, exports.FILTER_INLINE);
                    }
                    else if (binding.modifiers.nothing) {
                        el.innerHTML = (0, sanitize_html_1.default)(binding.value, exports.FILTER_NOTHING);
                    }
                    else {
                        el.innerHTML = (0, sanitize_html_1.default)(binding.value, options1);
                    }
                }
            }
        });
    },
    defaults: exports.FILTER_BASIC
};
exports.default = VSanitize;
//# sourceMappingURL=sanitize.js.map